<div class="tab-container">
  <div class="menu-header">
    <a class="menu-header__abas" (click)="toggleSidenav()">
      <img src="/assets/images/simbolos/menu.svg" alt="Menu">
    </a>
    <img class="menu-header__logo" alt="Logo">
  </div>

  <div class="menu-content">
    <div class="menu-usuario">
      <img src="/assets/images/simbolos/fotoPerfil.png" class="menu-usuario__foto" alt="Foto">
      <a class="menu-usuario__nome">{{nomeUsuario}}</a>
    </div>

    <a class="menu-opcoes" [matMenuTriggerFor]="menu" aria-label="Menu">
      <img src="/assets/images/simbolos/more-vert.svg" alt="Opções">
    </a>
    <mat-menu #menu="matMenu">
      <button mat-menu-item routerLink="alterar-senha">
        <mat-icon>settings</mat-icon>
        <span>Alterar senha</span>
      </button>
      <button mat-menu-item disabled>
        <mat-icon>account_circle</mat-icon>
        <span>Acesso</span>
      </button>
    </mat-menu>

  </div>
</div>